module.exports = __webpack_public_path__ + "img/about_2.25ffb80a.jpg";